import l10n from "diy/util/l10n";
import {notificationCenterObserver} from "diy/externalwebsiteimport/NotifierObservers/NotificationCenterObserver";

import Type from "../definitions/Type";
import Severity from "../definitions/Severity";
import {NotificationConfig} from "../definitions/Config";

export default {
    type: Type.EXTERNAL_WEBSITE_IMPORT_STARTED,
    testId: "external-website-import-started",
    trackingId: "ExternalWebsiteImportStartedNotification",

    content: l10n("migration.notification.init.text"),
    severity: Severity.HIGH,

    dismissAction: {
        testId: "skip-import",
        label: l10n("migration.notification.init.button.reject"),
        onClick: () => {
            if (typeof notificationCenterObserver.dismissHandler === "function") {
                notificationCenterObserver.dismissHandler();
            }
        }
    },
    mainAction: {
        testId: "start-import",
        label: l10n("migration.notification.init.button.start"),
        onClick: () => {
            if (typeof notificationCenterObserver.actionHandler === "function") {
                notificationCenterObserver.actionHandler();
            }
        }
    },

    bubbleOptions: {
        autoHide: false
    },

    cardOptions: {
        hidden: true
    }

} as NotificationConfig;



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/toolbar/notificationNG/types/ExternalWebsiteImportStarted.ts
 **/